import { resolveComponent as p, resolveDirective as W, openBlock as n, createElementBlock as u, createElementVNode as i, createVNode as m, Transition as g, withCtx as h, createCommentVNode as f, withDirectives as k, renderSlot as c, vShow as O, normalizeClass as x, createBlock as _, Teleport as B, withModifiers as $, toDisplayString as w, createTextVNode as E, Fragment as C, reactive as L, onBeforeUnmount as R, normalizeStyle as z, TransitionGroup as I, renderList as A } from "vue";
import { _ as v } from "./_plugin-vue_export-helper-dad06003.js";
import { M as D } from "./MenuRightIcon-eeb404cf.js";
import { B as V, a as M } from "./ButtonCloseSm-209b27c6.js";
import { A as T } from "./ArrowLeftIcon-c3971030.js";
import { L as vt } from "./CardVideo-a346405d.js";
import "./FormRichText.model-53e072ea.js";
import { C as H } from "./CardShortcut-d8584bdc.js";
import "./glightbox-13d8fc52.js";
import { C as N } from "./CheckCircleIcon-17128890.js";
import { E as P } from "./EasyToolsIcon-fea59351.js";
import { S as j } from "./StepsProgress-89c44b44.js";
import { TagMd as U } from "./tags.js";
import { B as Q } from "./ButtonResize-607b922f.js";
import { A as q } from "./AlertComponent-7cd7e75e.js";
import "./PreloaderIcon-b44be854.js";
import "./XIcon-e21df3cc.js";
import "./HelpIcon-2069ddad.js";
import "./ButtonPlay-d3872713.js";
import "./useNotificationHandler.js";
import "./DownloadFileIcon-8a003268.js";
import "./BarProgressMd-c3ebb73b.js";
import "./ChevronLeftIcon-b6affe9b.js";
import "./_commonjsHelpers-10dfc225.js";
import "./ChevronDoubleLeftIcon-1f939a0e.js";
import "./AlertCircleIcon-61966fff.js";
import "./AlertTriangleIcon-d613f6a8.js";
import "./ButtonCloseSmXs-a1e8d8e7.js";
const F = {
  name: "LayoutSidebar",
  components: {
    ButtonCloseSm: V,
    MenuRightIcon: D
  },
  props: {
    isOpen: {
      type: Boolean,
      default: !1
    },
    hideBorder: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:isOpen"],
  computed: {
    hasHeaderSlot() {
      var e;
      return !!((e = this.$slots) != null && e.header);
    },
    isSidebarOpen: {
      get() {
        return this.isOpen;
      },
      set(e) {
        this.$emit("update:isOpen", e);
      }
    }
  },
  watch: {
    isSidebarOpen: {
      handler(e) {
        window.innerWidth < 1024 && (document.body.style.overflow = e ? "hidden" : "");
      },
      immediate: !0
    }
  },
  mounted() {
    document.addEventListener("keydown", this.closeOnEsc, !0);
  },
  beforeUnmount() {
    document.removeEventListener("keydown", this.closeOnEsc, !0);
  },
  methods: {
    closeOnEsc(e) {
      e.key === "Escape" && this.isSidebarOpen && (e.stopPropagation(), e.preventDefault(), this.closeSidebar());
    },
    closeSidebar() {
      this.isSidebarOpen = !1;
    }
  }
}, G = { class: "ct-bg-1--alt" }, X = {
  class: "relative z-50 lg:hidden",
  role: "dialog",
  "aria-modal": "true"
}, J = {
  key: 0,
  class: "fixed inset-0 ct-bg-overlay"
}, K = { class: "fixed inset-0 flex" }, Y = {
  key: 0,
  class: "relative mr-16 flex w-full max-w-xs flex-1"
}, Z = {
  key: 0,
  class: "absolute left-full top-0 flex w-16 justify-center pt-5"
}, ee = { class: "flex grow flex-col ct-bg-1 lg:ct-bg-2--alt overflow-y-auto" }, te = { class: "hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col border-r ct-border-2" }, se = { class: "flex grow flex-col ct-bg-2--alt overflow-y-auto no-scrollbar" }, oe = { class: "p-6 pb-0 ct-text-1" }, ie = { class: "lg:pl-72 min-h-screen mx-auto max-w-[1728px] flex flex-col" }, le = { class: "block lg:hidden flex-1 h-7 ct-text-1" }, ne = { class: "hidden lg:block w-full" }, re = {
  key: 0,
  class: "block lg:hidden px-5 py-4"
}, de = { class: "flex flex-col flex-grow" };
function ae(e, t, s, d, l, o) {
  const a = p("ButtonCloseSm"), r = p("MenuRightIcon"), b = W("click-outside");
  return n(), u("div", G, [
    i("div", X, [
      m(g, { name: "fade-linear" }, {
        default: h(() => [
          o.isSidebarOpen ? (n(), u("div", J)) : f("", !0)
        ]),
        _: 1
      }),
      m(g, { name: "pretend-transition" }, {
        default: h(() => [
          k(i("div", K, [
            m(g, { name: "slide" }, {
              default: h(() => [
                o.isSidebarOpen ? k((n(), u("div", Y, [
                  m(g, { name: "fade" }, {
                    default: h(() => [
                      o.isSidebarOpen ? (n(), u("div", Z, [
                        m(a, { onClick: o.closeSidebar }, null, 8, ["onClick"])
                      ])) : f("", !0)
                    ]),
                    _: 1
                  }),
                  i("div", ee, [
                    c(e.$slots, "sidebar")
                  ])
                ])), [
                  [b, o.closeSidebar]
                ]) : f("", !0)
              ]),
              _: 3
            })
          ], 512), [
            [O, o.isSidebarOpen]
          ])
        ]),
        _: 3
      })
    ]),
    i("div", te, [
      i("div", se, [
        i("div", oe, [
          c(e.$slots, "logo", { class: "h-8" })
        ]),
        c(e.$slots, "sidebar")
      ])
    ]),
    i("div", ie, [
      i("div", {
        class: x(["sticky top-0 z-40 flex h-20 shrink-0 items-center gap-x-4 ct-bg-2--alt lg:ct-bg-1--alt px-5 sm:gap-x-6 sm:px-5", [
          o.hasHeaderSlot ? "" : "lg:hidden",
          s.hideBorder ? "" : "border-b ct-border-2"
        ]])
      }, [
        i("div", le, [
          c(e.$slots, "logo")
        ]),
        i("button", {
          class: "flex items-center justify-center lg:hidden w-10 h-10 p-2 rounded-lg",
          onClick: t[0] || (t[0] = (y) => o.isSidebarOpen = !0)
        }, [
          m(r, { class: "h-6 w-6 ct-fg-3" })
        ]),
        i("div", ne, [
          c(e.$slots, "header")
        ])
      ], 2),
      o.hasHeaderSlot ? (n(), u("div", re, [
        c(e.$slots, "header")
      ])) : f("", !0),
      i("main", de, [
        c(e.$slots, "main")
      ])
    ])
  ]);
}
const ht = /* @__PURE__ */ v(F, [["render", ae]]), ce = {
  name: "LayoutDrawer",
  components: {
    CardShortcut: H,
    ArrowLeftIcon: T,
    ButtonSecondaryIconSm: M
  },
  props: {
    modelValue: {
      type: Boolean,
      default: !0
    },
    size: {
      type: String,
      default: "sm"
    },
    title: {
      type: String,
      default: ""
    },
    showBackButton: {
      type: Boolean,
      default: !1
    },
    canClose: {
      type: Boolean,
      default: !0
    },
    // if one drawer opens another, it should set isChild to true
    isChild: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      isOpenWithDelay: !1
    };
  },
  computed: {
    isOpen: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.isOpenWithDelay = e, setTimeout(
          () => {
            this.$emit("update:modelValue", e);
          },
          e ? 0 : 300
        ), document.body.style.overflow = e ? "hidden" : "";
      }
    }
  },
  watch: {
    modelValue: {
      immediate: !0,
      handler(e) {
        this.isOpenWithDelay = e, document.body.style.overflow = e ? "hidden" : "";
      }
    }
  },
  mounted() {
    document.addEventListener("keydown", this.closeOnEsc, this.isChild);
  },
  beforeUnmount() {
    document.removeEventListener("keydown", this.closeOnEsc, this.isChild);
  },
  methods: {
    closeOnEsc(e) {
      e.key === "Escape" && (e.stopImmediatePropagation(), e.preventDefault(), this.close());
    },
    // used outside of this component with $refs.drawer.close()
    close(e = !1) {
      (e || this.canClose) && (this.isOpen = !1);
    }
  }
}, ue = { class: "ct-bg-1--alt" }, me = {
  class: "relative z-50",
  role: "dialog",
  "aria-modal": "true"
}, fe = { class: "flex grow flex-col ct-bg-1--alt overflow-y-auto" }, he = { class: "flex-shrink-0 h-20 flex items-center space-x-2 px-6 border-b ct-border-2" }, pe = { class: "flex-grow text-lg ct-text-1 font-medium" };
function ge(e, t, s, d, l, o) {
  const a = p("ArrowLeftIcon"), r = p("ButtonSecondaryIconSm"), b = p("CardShortcut");
  return n(), _(B, { to: "body" }, [
    i("div", ue, [
      i("div", me, [
        m(g, {
          name: "fade-linear",
          appear: ""
        }, {
          default: h(() => [
            l.isOpenWithDelay ? (n(), u("div", {
              key: 0,
              class: x(["fixed inset-0", { "ct-bg-overlay": !s.isChild }])
            }, null, 2)) : f("", !0)
          ]),
          _: 1
        }),
        m(g, {
          name: "pretend-transition",
          appear: ""
        }, {
          default: h(() => [
            k(i("div", {
              class: "fixed inset-0 flex justify-end",
              onClick: t[3] || (t[3] = (y) => o.close())
            }, [
              m(g, {
                name: "slide-back",
                appear: ""
              }, {
                default: h(() => [
                  l.isOpenWithDelay ? (n(), u("div", {
                    key: 0,
                    class: x(["relative flex w-full flex-1", {
                      "sm:max-w-xs": s.size === "sm",
                      "sm:max-w-md": s.size === "md",
                      "sm:max-w-2xl": s.size === "2xl",
                      "sm:max-w-5xl": s.size === "5xl"
                    }]),
                    onClick: t[2] || (t[2] = $(() => {
                    }, ["stop"]))
                  }, [
                    i("div", fe, [
                      i("div", he, [
                        c(e.$slots, "before-title"),
                        s.showBackButton ? (n(), _(r, {
                          key: 0,
                          onClick: t[0] || (t[0] = (y) => o.close(!0))
                        }, {
                          default: h(() => [
                            m(a)
                          ]),
                          _: 1
                        })) : f("", !0),
                        i("p", pe, w(s.title), 1),
                        s.canClose ? (n(), _(b, {
                          key: 1,
                          class: "cursor-pointer flex-shrink-0",
                          onClick: t[1] || (t[1] = (y) => o.close())
                        }, {
                          default: h(() => t[4] || (t[4] = [
                            E(" ESC ")
                          ])),
                          _: 1,
                          __: [4]
                        })) : f("", !0),
                        c(e.$slots, "after-title")
                      ]),
                      c(e.$slots, "drawer")
                    ])
                  ], 2)) : f("", !0)
                ]),
                _: 3
              })
            ], 512), [
              [O, l.isOpenWithDelay]
            ])
          ]),
          _: 3
        })
      ])
    ])
  ]);
}
const pt = /* @__PURE__ */ v(ce, [["render", ge]]), be = {
  name: "LayoutSteps",
  components: {
    EasyToolsIcon: P,
    StepsProgress: j,
    TagMd: U,
    CheckCircleIcon: N
  },
  props: {
    steps: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    currentStep() {
      return this.steps.find((e) => e.current);
    }
  }
}, xe = { class: "fixed inset-0 z-50 flex flex-col lg:flex-row ct-bg-1 py-16 lg:py-0 px-5 lg:px-0 overflow-y-auto lg:overflow-hidden" }, _e = {
  key: 0,
  class: "flex-shrink-0 w-full lg:max-w-md mb-4 lg:mb-0 lg:p-8 lg:ct-bg-2--alt flex flex-col items-center lg:items-start"
}, ye = { class: "flex-grow flex flex-col items-center lg:pt-40 lg:pb-24 lg:overflow-y-auto" }, ve = { class: "w-full max-w-[360px] flex flex-col items-center" }, we = { class: "hidden lg:block mb-8" }, Se = {
  key: 1,
  class: "w-12 h-12 flex items-center justify-center ct-bg-success--2 rounded-lg"
}, ke = { class: "text-xl lg:text-3xl font-semibold ct-text-1 mb-3 text-center" }, Ce = { class: "text-sm lg:text-base ct-text-3 text-center" }, ze = { class: "w-full mt-8" };
function Oe(e, t, s, d, l, o) {
  const a = p("EasyToolsIcon"), r = p("StepsProgress"), b = p("TagMd"), y = p("CheckCircleIcon");
  return n(), u(C, null, [
    i("div", xe, [
      o.currentStep.hideSteps ? f("", !0) : (n(), u("div", _e, [
        m(a, { class: "h-7 lg:h-8 mb-7 lg:mb-16" }),
        m(r, { steps: s.steps }, null, 8, ["steps"])
      ])),
      i("div", ye, [
        i("div", ve, [
          i("div", we, [
            o.currentStep.hideSteps ? (n(), u("div", Se, [
              m(y, { class: "h-6 w-6 text-success-600 dark:text-success-200" })
            ])) : (n(), _(b, { key: 0 }, {
              default: h(() => [
                E(w(o.currentStep.name), 1)
              ]),
              _: 1
            }))
          ]),
          i("p", ke, w(o.currentStep.longTitle ? o.currentStep.longTitle : o.currentStep.title), 1),
          i("p", Ce, w(o.currentStep.description), 1),
          i("div", ze, [
            c(e.$slots, "default")
          ])
        ])
      ])
    ]),
    c(e.$slots, "main")
  ], 64);
}
const gt = /* @__PURE__ */ v(be, [["render", Oe]]);
function S(e) {
  return isNaN(e) ? e : `${e}px`;
}
function Be(e) {
  let t = "screen and ";
  return Array.isArray(e) ? (t += `(min-width: ${S(e[0])})`, e.length === 2 && (t += ` and (max-width: ${S(e[1])})`), t) : isNaN(parseInt(e)) ? String(e).replace(/^@?media/i, "").trim() : (t += `(max-width: ${S(e)})`, t);
}
function Ee(e, t, s) {
  if (!e[t])
    throw new Error(`Event of type "${t}" is not available for registration`);
  e[t].indexOf(s) === -1 && e[t].push(s);
}
function We(e, t, s) {
  if (!e[t])
    throw new Error(`Event of type "${t}" is not available for unregistration`);
  if (s === void 0)
    e[t] = [];
  else {
    let d = e[t].indexOf(s);
    d !== -1 && e[t].splice(d, 1);
  }
}
function $e(e, t) {
  e.forEach((s) => s(t));
}
function Le(e, t, s) {
  const d = window.matchMedia(Be(t)), l = {
    enter: [],
    leave: []
  };
  s[e] = {
    matches: d.matches,
    on(a, r) {
      Ee(l, a, r);
    },
    off(a, r) {
      We(l, a, r);
    }
  };
  const o = (a) => {
    s[e].matches = a.matches, $e(a.matches ? l.enter : l.leave, d);
  };
  d.addListener(o), R(() => {
    d.removeListener(o);
  });
}
function Re(e) {
  const t = L({});
  return Object.keys(e).forEach((s) => {
    Le(s, e[s], t);
  }), t;
}
const Ie = {
  name: "LayoutPage",
  components: {
    ButtonResize: Q
  },
  props: {
    isResizable: {
      type: Boolean,
      default: !0
    },
    sidebarWidth: {
      type: Number,
      default: 400,
      required: !1
    }
  },
  setup() {
    return {
      breakpoints: Re({
        lg: [1024]
      })
    };
  },
  data() {
    return {
      sidebarHidden: !1,
      defaultSidebarWidth: this.sidebarWidth,
      localSidebarWidth: this.sidebarWidth,
      isResizing: !1
    };
  },
  watch: {
    sidebarWidth: {
      handler(e) {
        this.defaultSidebarWidth = e, this.localSidebarWidth = e;
      },
      immediate: !0
    }
  },
  methods: {
    startResizing() {
      document.addEventListener("mousemove", this.resizeSidebar, !1), document.addEventListener("mouseup", this.stopResizing, !1);
    },
    stopResizing() {
      this.isResizing = !1, document.removeEventListener("mousemove", this.resizeSidebar, !1);
    },
    resizeSidebar(e) {
      this.isResizing = !0;
      const t = e.clientX, s = 460, d = window.innerWidth - s;
      t >= this.defaultSidebarWidth - 24 && t <= d ? this.localSidebarWidth = t : t > d ? (this.localSidebarWidth = d, this.stopResizing()) : (this.sidebarHidden = !0, this.localSidebarWidth = this.defaultSidebarWidth, this.stopResizing());
    },
    toggleSidebar() {
      this.localSidebarWidth = this.defaultSidebarWidth, this.sidebarHidden = !this.sidebarHidden;
    }
  }
}, Ae = { class: "relative flex-grow flex lg:overflow-hidden pb-14 lg:pb-0" }, De = {
  key: 0,
  class: "hidden lg:block absolute top-16 right-0 transform translate-x-full -translate-y-full z-20"
}, Ve = {
  key: 0,
  class: "w-24 h-full"
};
function Me(e, t, s, d, l, o) {
  const a = p("ButtonResize");
  return n(), u("div", {
    class: x(["lg:h-screen flex flex-col ct-bg-2", [l.isResizing ? "select-none" : ""]])
  }, [
    c(e.$slots, "header"),
    i("div", Ae, [
      i("div", {
        ref: "sidebar",
        class: x(["relative lg:absolute z-20 left-0 top-0 bottom-0 ct-bg-1 border-r ct-border-2 w-full transition-transform", { "-translate-x-full": l.sidebarHidden }]),
        style: z({ width: d.breakpoints.lg.matches ? l.localSidebarWidth + "px" : "100%" })
      }, [
        c(e.$slots, "sidebar"),
        s.isResizable ? (n(), u(C, { key: 0 }, [
          l.sidebarHidden ? (n(), u("div", De, [
            m(a, {
              fold: l.sidebarHidden,
              onClick: o.toggleSidebar
            }, null, 8, ["fold", "onClick"])
          ])) : f("", !0),
          l.sidebarHidden ? f("", !0) : (n(), u("div", {
            key: 1,
            class: "group hidden lg:flex absolute top-0 bottom-0 right-1 transform translate-x-full z-20 cursor-col-resize h-full px-1",
            onMousedown: t[0] || (t[0] = (...r) => o.startResizing && o.startResizing(...r)),
            onDblclick: t[1] || (t[1] = (r) => l.localSidebarWidth = l.defaultSidebarWidth)
          }, [
            t[2] || (t[2] = i("div", { class: "w-[3px] h-full bg-transparent group-hover:bg-sky-500 transition-colors group-hover:delay-300 duration-300 ease-in-out" }, null, -1)),
            l.isResizing ? (n(), u("div", Ve)) : f("", !0)
          ], 32))
        ], 64)) : f("", !0)
      ], 6),
      i("main", {
        class: x(["hidden lg:flex relative flex-grow items-stretch", { "transition-all": !l.isResizing }]),
        style: z({
          "margin-left": l.sidebarHidden ? "0px" : l.localSidebarWidth + "px"
        })
      }, [
        c(e.$slots, "preview")
      ], 6),
      c(e.$slots, "footer")
    ])
  ], 2);
}
const bt = /* @__PURE__ */ v(Ie, [["render", Me]]), Te = {
  components: {
    AlertComponent: q
  },
  props: {
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  emits: ["update:modelValue"],
  computed: {
    alerts: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  },
  methods: {
    closeAlert(e) {
      let t = this.alerts.indexOf(e);
      t > -1 && this.alerts.splice(t, 1);
    }
  }
};
function He(e, t, s, d, l, o) {
  const a = p("AlertComponent");
  return n(), _(B, { to: "body" }, [
    m(I, {
      tag: "ul",
      name: "list",
      class: "fixed bottom-0 sm:bottom-6 left-0 sm:left-auto right-0 sm:right-6 sm:space-y-2 z-[60] w-full sm:max-w-[400px]"
    }, {
      default: h(() => [
        (n(!0), u(C, null, A(o.alerts, (r) => (n(), _(a, {
          key: r,
          type: r.type,
          title: r.title,
          message: r.message,
          "no-close": r.noClose,
          onClose: (b) => o.closeAlert(r)
        }, null, 8, ["type", "title", "message", "no-close", "onClose"]))), 128))
      ]),
      _: 1
    })
  ]);
}
const xt = /* @__PURE__ */ v(Te, [["render", He]]);
export {
  xt as LayoutAlerts,
  pt as LayoutDrawer,
  vt as LayoutModal,
  bt as LayoutPage,
  ht as LayoutSidebar,
  gt as LayoutSteps
};
